$(function (ws) {
    'use strict';

    ws.views.lookupSelect2Option = Backbone.View.extend({

        /**
         * Events
        */
        events: {
            change: 'onDropdownChange'
        },

        /**
        * Initializes the component.
        */
        initialize() {
            this.id = this.$el.attr('id');
        },

        onDropdownChange: function()  {
            if (this.id) {
                this.eventAgg.trigger(`${this.id}:change`, this.$el.find('option:selected').val(), this.$el);
            }
        }
    });
}(westcon));
